import { Component, OnInit, Input} from '@angular/core';
import { ActivatedRoute, Params, Router }   from '@angular/router';
import { WebService } from '../services/web/web.service';
import { EncryptService } from '../services/encrypt/encrypt.service';
import { DialogService } from '../services/dialog/dialog.service';

import {trigger, state, style, transition, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']

})
export class LoginComponent implements OnInit {
  flag :string;
	email:string;
	password:string;
  state:any;
  loginFailed:any;
  gStorageSupported:any;
  errMessage:any=""//added by vijay

  constructor(private router:Router,private httpService:WebService,private encryptService:EncryptService,private dialogService:DialogService) { }

  ngOnInit() {
  	this.email 		= localStorage.getItem('email');
  	this.password   = localStorage.getItem('password');
    if(this.localStorageSupported){
      if(localStorage.getItem('token')){
        this.router.navigate(['/wisefly']);
      }
    }else{
      this.dialogService.openAlert("Please update your safari browser to version 11 or more")
            .then(data=>{
              console.log(data);
            });
    }
    
  }

  loginAdmin(){
  	this.encryptService.encryptPassword(this.password)
  	.then(encrypted=>{
 
  		let pass = encrypted['encrypted'];
  		this.httpService.getResponse('/loginroute/authenticate',{email:this.email,password:pass})
  		.then(res=>{
  			let data = res.json();
  			if(data['success']){
          if(data['role'] != 'admin_created'){
            //can't allow users of this app to access admin data
            return;
          }
          //console.log(data);
  				localStorage.setItem('token',data['token']);
  				localStorage.setItem('email',this.email);
          localStorage.setItem('_id',data['_id']);
          localStorage.setItem('appname',data['appname']);
  				localStorage.setItem('password',this.password);
          localStorage.setItem('isAdmin',data['is_admin']);
          localStorage.setItem('profilePic',data['profile_pic']);
          if(data['is_feedbackAdmin']!=undefined)
            localStorage.setItem('is_feedbackAdmin',data['is_feedbackAdmin']);
          else
            localStorage.setItem('is_feedbackAdmin','false');

  				//redirecting to budapest manually should be done according to the app
  				this.router.navigate(['/wisefly']);
  			}else{
  				if(data['status'] == 0){
  					this.dialogService.openAlert("There was some error while retrieving the data")
			  		.then(data=>{
			  			console.log(data);
			  		});
  				}else if(data['status'] == 1){
  					this.dialogService.openAlert("No user registered with this email for this particular app")
			  		.then(data=>{
			  			console.log(data);
			  		});
  				}else if(data['status'] == 2){
  					this.loginFailed = true;
            this.flag="wrongpw";
			  		
          }

          }
  		})
  		.catch(err=>{
  			this.dialogService.openAlert(err.toString())
	  		.then(data=>{
	  			console.log(data);
	  		});
  		})
  	}).catch(err=>{
  		this.dialogService.openAlert(err.toString())
  		.then(data=>{
  			console.log(data);
  		});
  	})
  }
  getCSSClasses() {
      
       if(this.flag == "wrongpw") {  
           return "oneClass"
       }

return ""


        }

        
 localStorageSupported() {
    var testKey = 'test', storage = localStorage;
    if( this.gStorageSupported === undefined ) {
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            this.gStorageSupported = true;
        } catch (error) {
            this.gStorageSupported = false;
        }
    }
    return this.gStorageSupported;
}
getYear(){
  return new Date().getUTCFullYear();
}

//added by vijay
  forgotpassword(){    
    console.log("forgotpassword");
    console.log(this.email);
    this.errMessage="";
    
    //getuserbyemail
    this.httpService.getResponse("/userroute/getuserbyemail",{email:this.email}).then(res=>{
      
      let data= res.json()
      console.log(data)
     // console.log(data.data.length)

      if(data['data'] == null){
        console.log("user not register")
        this.errMessage ="* user not register"

      }else{
        this.httpService.getResponse("/forgotpasswordroute/forgotpassword",{email:this.email}).then(res=>{
          this.errMessage = "Email sent on your registered email id";
        }).catch(err=>{
            this.errMessage ="Something went wrong";
        })
      }
      
    }).catch(err=>{
      console.log(err);
      console.log("somthing went wrong")
    })
  }
//end added by vijay

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts